import { Component, computed, input, Optional, output, SkipSelf } from '@angular/core';

/**
 * services
 */
import { TableStateService } from '../../services';

/**
 * directives
 */
import { FormCheckFieldDirective } from '@forms/directives/form-check-field/form-check-field.directive';

@Component({
  selector: 'app-table-checkbox',
  templateUrl: './table-checkbox.component.html',
  styleUrl: './table-checkbox.component.scss',
  imports: [
    FormCheckFieldDirective,
  ],
})
export class TableCheckboxComponent {

  /**
   * @description Value of the checkbox
   */
  public value = input.required<any>();

  /**
   * @description Name of the checkbox
   */
  public name = input.required<string, string>({
    transform: (value: string) => value ? `table_row_select_${value}` : ''
  });

  /**
   * @description Id of the checkbox
   */
  public id = input.required<string, string>({
    transform: (value: string) => value ? `table_row_select_${value}` : ''
  });

  /**
   * @description Output event when the checkbox is changed
   */
  public onChange = output<unknown>();

  /**
   * @description Checked state of the checkbox
   */
  public checked = computed(() => this.tableState.isRowSelected(this.value()));

  /**
   * @description Constructor
   */
  constructor(
    @Optional()
    @SkipSelf()
    public readonly tableState: TableStateService
  ) {}

  /**
   * Method to handle the change event of the checkbox
   * @param event 
   */
  public onChangeHandler(event: unknown): void {

    const isSelected = event as boolean;

    this.tableState.onRowToggle(this.value(), isSelected);
    
    this.onChange.emit(isSelected);

  }

}
